var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSolarDocumentsMinimalisticLinear(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 8C5 5.172 5 3.757 5.879 2.879C6.757 2 8.172 2 11 2H13C15.828 2 17.243 2 18.121 2.879C19 3.757 19 5.172 19 8V16C19 18.828 19 20.243 18.121 21.121C17.243 22 15.828 22 13 22H11C8.172 22 6.757 22 5.879 21.121C5 20.243 5 18.828 5 16V8Z",
    stroke: "#FF9B04",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 13H15M9 9H15M9 17H12M2 19V5M22 19V5",
    stroke: "#FF9B04",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolarDocumentsMinimalisticLinear);
export default __webpack_public_path__ + "static/media/solar_documents-minimalistic-linear.8fea925d7da988b2aee3df7634cbb6f1.svg";
export { ForwardRef as ReactComponent };